// extracted by mini-css-extract-plugin
export default {"main_content":"style__main_content___RZNa","user_center_box":"style__user_center_box__zqJog","title":"style__title__LuPIG","status_box":"style__status_box__CFolv"};